export default {
  COMPLETE: 'complete',
  IN_PROGRESS: 'in_progress',
  FAILED: 'failed',
};
